<template>
  <b-container fluid>
    <loading :active="loading"
             :z-index="1000"
             :is-full-page="false"/>

    <esg-base-card title="협력사 모니터링"
                   v-show="!loading"
                   :footer="false">
      <template #default>
        <b-container style="max-width: 1400px"
                     id="EsgPartnerCorpMonitoring"
                     class="my-2 px-0">
          <b-row align-h="start">
            <b-col sm="8"
                   md="5"
                   lg="3">
              <esg-single-score-card title="핵심 협력사 수"
                                     :score="249"
                                     score-unit="사"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="8" align-self="center">
              <EsgPartnerCorpMonitoringGrid :gridId="0"/>
            </b-col>
            <b-col lg="4">
              <ct00035 id="dashboard-chart-35"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="8">
              <EsgPartnerCorpMonitoringGrid :gridId="1"/>
            </b-col>
            <b-col lg="4">
              <ct00036 :data="'test'"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="8">
              <EsgPartnerCorpMonitoringGrid :gridId="2"/>
            </b-col>
            <b-col lg="4">
              <ct00037 :data="'test'"/>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </esg-base-card>
  </b-container>
</template>
<script>
import ct00035 from '../charts/ct00035.vue'
import ct00036 from '../charts/ct00036.vue'
import ct00037 from '../charts/ct00037.vue'
import EsgCardHeader from "@/components/esg/base/EsgBaseCardHeader.vue";
import EsgPartnerCorpMonitoringGrid from "./EsgPartnerCorpMonitoringGrid.vue"
import EsgSingleScoreCard from "@/components/esg/base/EsgSingleScoreCard.vue";
import EsgBaseCard from "@/components/esg/base/EsgBaseCard.vue";

export default {
  name: 'EsgPartnerCorpMonitoring',
  components: {
    EsgBaseCard,
    EsgCardHeader,
    EsgPartnerCorpMonitoringGrid,
    ct00035,
    ct00036,
    ct00037,
    EsgSingleScoreCard
  },
  data() {
    return {
      loading: false
    }
  }
}
</script>
<style scoped>
#EsgPartnerCorpMonitoring >>> .card-body {
  height: 300px;
}
</style>